// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transactions__filters{display:-webkit-box;display:-ms-flexbox;display:flex;padding:2.9rem 3.5rem 2.4rem 4.1rem}@media (max-width:1229px){.transactions__filters{-ms-flex-wrap:wrap;flex-wrap:wrap;padding:2rem 1.8rem 2.4rem 2rem}}", ""]);
// Exports
module.exports = exports;
